import Vue                  from 'vue'
import App                  from './App.vue'
import router               from './router'
import store                from './store'
import vuetify              from './plugins/vuetify'

import VuetifySnackbarQueue from 'vuetify-snackbar-queue'
import VueSignaturePad      from 'vue-signature-pad';

import formattersMixin from './plugins/formattersMixin'
import systemMixin     from "@/plugins/systemMixin";

import './styles/extensions.scss';
import VueMeta         from "vue-meta";

Vue.config.productionTip = false

//application level plugins and mixins
Vue.mixin( systemMixin );
Vue.mixin( formattersMixin );

//third party plugins
Vue.use(VueMeta)
Vue.use( VuetifySnackbarQueue )
Vue.use(VueSignaturePad);

new Vue( {
	router,
	store,
	vuetify,
	beforeCreate: function() {
		// Subscribe to store updates
		store.subscribe( ( mutation, state ) => {
			console.log(mutation.type);
			// Store parts of the state
			if( mutation.type.startsWith( 'microsoftAuth' ) ) {
				localStorage.setItem( 'store.microsoftAuth', JSON.stringify( state.microsoftAuth ) );
			}
			if( mutation.type.startsWith( 'signaturesApi' ) ) {
				localStorage.setItem( 'store.signaturesApi', JSON.stringify( state.signaturesApiAuth ) );
			}
			if( mutation.type.startsWith( 'setShowAdvanced' ) ) {
				localStorage.setItem( 'store.showAdvanced', state.showAdvanced );
			}
		} );
		store.dispatch( 'initialize' ).then( function() {
		} );

	},
	render:       h => h( App )
} ).$mount( '#app' )